import { PUT_REDUX_DEFAULT_SESSION } from '../../reducers/constants';

const putReduxDefaultSession = () => ({
  type: PUT_REDUX_DEFAULT_SESSION,
});
export default putReduxDefaultSession;
